module.exports = __webpack_public_path__ + "media/icons/cross-c61a3dd5b1b1cbfb63220b7f6942d8d0.svg";